import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { Toast } from 'vant'
// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 60000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      //   notification.error({
      //     message: 'Forbidden',
      //     description: data.message
      //   })
      Toast.fail(data.message)
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      //   notification.error({
      //     message: 'Unauthorized',
      //     description: 'Authorization verification failed'
      //   })
      Toast.fail('Authorization verification failed')
      // if (token) {
      //     // store.dispatch('Logout').then(() => {
      //     //     setTimeout(() => {
      //     //         window.location.reload()
      //     //     }, 1500)
      //     // })
      // }
    }
    if (error.response.status === 404 && error.response.data.code === 401) {
      //   notification.error({
      //     message: 'Unauthorized',
      //     description: error.response.data.msg
      //   })
      Toast.fail(error.response.data.msg)
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {

    config.headers['webkey'] = process.env.VUE_APP_APPKEY_URL // 让每个请求携带自定义 token 请根据实际情况自行修改

  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  if(response.data.code==401){
    // Vue.ls.remove(ACCESS_TOKEN);
    // window.location.reload();
    return ;
  }
  // else if(response.data.code==200){
  //   return response.data
  // }else {
  //   notification.error({
  //     message: 'system error',
  //     description: response.data.message
  //   })
  // }
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
